namespace SorAraBul.Membership {
    export interface SignUpRequest extends Serenity.ServiceRequest {
        UserType?: UserType;
        DisplayName?: string;
        Email?: string;
        Password?: string;
        ConfirmPassword?: string;
        MobilePhoneNumber?: string;
        CompanyName?: string;
        TaxOffice?: string;
        TaxNumber?: string;
        AddressDetail?: string;
        CityId?: number;
        IlceId?: number;
        ContactNumber?: string;
        PostalCode?: string;
    }
}
